module.exports = __webpack_public_path__ + "img/Frame 936one.bbf97ab4.svg";